import React from 'react';
import { motion } from 'framer-motion';
import '../assets/styles/AboutPage.css';
import personalPhoto from '../assets/images/my-photo.jpg';

const AboutPage = () => (
  <div className="about-page">

    {/* Hero */}
    <section className="about-hero-section">
      <div className="about-hero-inner">
        <motion.p
          className="eyebrow"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          About
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          Rest easy — your website<br />
          <span>is in the right hands.</span>
        </motion.h1>
        <motion.p
          className="about-hero-description"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          We handle everything from strategy to launch so you can focus on running your business.
        </motion.p>
      </div>
    </section>

    {/* Introduction */}
    <motion.section
      id="personal-introduction"
      className="about-introduction"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      viewport={{ once: true, amount: 0.2 }}
    >
      <div className="intro-container">
        <motion.div
          className="intro-image"
          initial={{ opacity: 0, x: -24 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          viewport={{ once: true }}
        >
          <img src={personalPhoto} alt="Ajani Anderson" className="personal-photo" />
        </motion.div>

        <motion.div
          className="intro-text"
          initial={{ opacity: 0, x: 24 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <p className="eyebrow">Who I am</p>
          <h2>Builder. Designer. Partner.</h2>
          <p className="body-lora">
            As the founder of <strong>Next Level Websites</strong>, I specialize in helping small businesses elevate their online presence. With years of experience in web design, branding, and development, I'm passionate about creating digital solutions that truly make an impact.
          </p>
          <p className="body-lora">
            My goal is to combine creativity, functionality, and your vision to deliver a website that not only looks great but also achieves your business objectives.
          </p>
          <a href="/get-started" className="btn-primary-warm" style={{ marginTop: '8px', display: 'inline-block' }}>
            Start a project
          </a>
        </motion.div>
      </div>
    </motion.section>

    {/* Is This For Me */}
    <motion.section
      className="about-is-this-for-me"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      viewport={{ once: true, amount: 0.2 }}
    >
      <p className="eyebrow centered">Fit check</p>
      <h2 className="centered">Is this for you?</h2>
      <p style={{ textAlign: 'center', marginTop: '8px' }}>You are a great fit if any of these sound familiar:</p>
      <ul>
        <li>You're ready to stand out online with a unique, high-performing website.</li>
        <li>Your current site isn't aligned with your brand or converting visitors.</li>
        <li>You want a smooth, collaborative design process from start to finish.</li>
        <li>You value both aesthetics and functionality in your website.</li>
        <li>You're looking for a long-term partner who understands your business goals.</li>
      </ul>
    </motion.section>

    {/* CTA */}
    <motion.section
      className="about-contact-cta"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      viewport={{ once: true, amount: 0.2 }}
    >
      <p className="eyebrow" style={{ color: 'rgba(242,241,237,0.5)', textAlign: 'center' }}>Ready?</p>
      <h2>Let's build something amazing together</h2>
      <p>
        Whether you're starting from scratch or looking to revamp your existing site, I'm here to help. Let's collaborate to create a digital solution that represents your brand and drives growth.
      </p>
      <a href="/get-started" className="btn-accent">Get started</a>
    </motion.section>

  </div>
);

export default AboutPage;
